import React, { useState, useMemo } from 'react';
import { FiEdit2, FiTrash2, FiEye, FiEdit3, FiSearch, FiFilter } from 'react-icons/fi';
import importacaoService from '../services/importacaoService';
import toast from 'react-hot-toast';
import { STATUS } from '../constants/status';
import ImportacaoDetalhesModal from './ImportacaoDetalhesModal';

export default function ImportacaoList({ importacoes, onRefresh, onEmbarcarClick, onEditClick }) {
  const [detalhesModalOpen, setDetalhesModalOpen] = useState(false);
  const [importacaoParaDetalhes, setImportacaoParaDetalhes] = useState(null);

  const [termoBusca, setTermoBusca] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');

  const importacoesFiltradas = useMemo(() => {
    return importacoes.filter((item) => {

      const matchProduto = item.produto.toLowerCase().includes(termoBusca.toLowerCase());

      const matchStatus = filtroStatus === '' ? true : item.status === filtroStatus;

      return matchProduto && matchStatus;
    });
  }, [importacoes, termoBusca, filtroStatus]);

  const handleDeletarImportacao = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar? Isso apagará todos os pagamentos vinculados.')) {
      try {
        await importacaoService.deletar(id);
        toast.success('Importação removida');
        onRefresh();
      } catch (error) {
        toast.error('Erro ao deletar');
      }
    }
  };

  const handleAbrirDetalhes = (importacao) => {
    setImportacaoParaDetalhes(importacao);
    setDetalhesModalOpen(true);
  };

  const formatarMoeda = (valor) => {
    return valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || 'R$ 0,00';
  };

  const formatarData = (data) => {
    return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  return (
    <>
      {}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-4 flex flex-col sm:flex-row gap-4 justify-between items-center border border-slate-200">

        {}
        <div className="relative w-full sm:w-96">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FiSearch className="text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Buscar por nome do produto..."
            value={termoBusca}
            onChange={(e) => setTermoBusca(e.target.value)}
            className="block w-full pl-10 pr-3 py-2 border border-slate-200 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm transition-shadow"
          />
        </div>

        {}
        <div className="w-full sm:w-64 flex items-center gap-2">
          <div className="p-2 bg-gray-100 rounded-lg text-gray-500"><FiFilter /></div>
          <select
            value={filtroStatus}
            onChange={(e) => setFiltroStatus(e.target.value)}
            className="block w-full py-2 px-3 border border-slate-200 bg-white rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm cursor-pointer"
          >
            <option value="">Todos os Status</option>
            <option value={STATUS.PENDENTE}>Somente Pendentes</option>
            <option value={STATUS.DESEMBARACADO}>Somente Desembaraçados</option>
          </select>
        </div>
      </div>

      {}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-slate-200">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">ID</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">Produto</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">Valor Inicial</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">30% Pago</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">Total Geral</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">Status</th>
                <th className="px-6 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">

              {}
              {importacoesFiltradas.length > 0 ? (
                importacoesFiltradas.map((item) => (
                  <tr key={item.id} className="hover:bg-slate-50 transition-colors group">
                    <td className="px-6 py-4">
                      <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded-md text-[10px] font-black border border-gray-200">
                        #{item.id}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-bold text-gray-900">{item.produto}</div>
                      <div className="text-[10px] text-gray-400 font-medium uppercase">{formatarData(item.dataImportacao)}</div>
                    </td>
                    <td className="px-6 py-4 text-right font-mono text-sm text-slate-700">
                      {item.moeda} {item.valorInicial?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                    <td className="px-6 py-4 text-right font-mono text-sm text-slate-700">{formatarMoeda(item.valorPago30)}</td>
                    <td className="px-6 py-4 text-right font-mono text-sm font-semibold text-slate-900">{formatarMoeda(item.totalProjecao)}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2.5 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wide ${
                        item.status === STATUS.DESEMBARACADO ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'
                      }`}>
                        {item.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center gap-3">
                        <button onClick={() => handleAbrirDetalhes(item)} className="p-1.5 text-gray-400 hover:text-blue-600 transition" title="Ver Detalhes">
                          <FiEye size={18} />
                        </button>
                        <button onClick={() => onEditClick(item)} className="p-1.5 text-gray-400 hover:text-orange-500 transition" title="Editar">
                          <FiEdit3 size={18} />
                        </button>
                        {item.status !== STATUS.DESEMBARACADO && (
                          <button onClick={() => onEmbarcarClick(item)} className="p-1.5 text-blue-500 hover:text-blue-700 transition" title="Embarcar">
                            <FiEdit2 size={18} />
                          </button>
                        )}
                        <button onClick={() => handleDeletarImportacao(item.id)} className="p-1.5 text-red-300 hover:text-red-600 transition" title="Excluir">
                          <FiTrash2 size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="px-6 py-12 text-center text-gray-500">
                    Nenhuma importação encontrada com os filtros atuais.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ImportacaoDetalhesModal 
        isOpen={detalhesModalOpen}
        importacao={importacaoParaDetalhes}
        onUpdate={onRefresh}
        onClose={() => {
          setDetalhesModalOpen(false);
          setImportacaoParaDetalhes(null);
        }}
      />
    </>
  );
}